module.exports = __webpack_public_path__ + "static/media/logo.68023d48.svg";